export default "__VITE_ASSET__FqQt5vmm__"